import { getPageSetFromPath } from "@pageDefinitions/pageSets";
import { findEntryPointLocation } from "src/pageDefinitions/actions/survey/util";
import getStore from "src/utils/redux/store";
import { gotoPage } from "./pageSet";
import { getHistory } from "../components/PageSetRouter";
import {
  MED_SKU,
  MED_FLOW,
  getEligibleMedProducts,
  getBMI,
} from "@utils/medEligibility";
import { trackEvent } from "src/utils/api/tracker";
import goto from ".";

export const medSkuEntryPoints = {
  [MED_SKU.ORALS_METFORMIN]: "medOralsPlan",
  [MED_SKU.COMPOUNDED]: "medCompoundedAndLiraglutidePlan",
  [MED_SKU.GENERIC_LIRAGLUTIDE]: "medCompoundedAndLiraglutidePlan",
  [MED_SKU.COMPOUNDED_MICRODOSE]: "medMicrodosePlan",
  [MED_SKU.BRANDED]: "medBrandedPlan",
  [MED_SKU.BRANDED_ZEPBOUND_VIAL]: "medBrandedZepboundVialPlan",
  [MED_SKU.HRT_CREAM]: "hrtCreamPlan",
  [MED_SKU.HRT_PATCH]: "hrtPatchPlan",
  [MED_SKU.COMPOUNDED_MICRODOSE_PROACTIVE_HEALTH_BIOMARKER]:
    "medProactiveHealthMicrodoseBiomarkerPlan",
};

export default {
  async navigateToPlanRevealPage() {
    const store = getStore();
    const history = getHistory();
    const pageSet = await getPageSetFromPath(
      window.location.pathname,
      getStore().getState()
    );

    const { flow, recommendedMedTier } = store.getState().recommendationContext;
    const entryPoint = medSkuEntryPoints[recommendedMedTier];

    if (flow === MED_FLOW.CLINICAL && !entryPoint) {
      // Temporary adding logic with event to measure how many users are experiencing
      // the Med loop due to the old stored data https://noomhq.atlassian.net/browse/MGEXP-2227
      const eligibleProducts = getEligibleMedProducts(
        {
          checkBMI: true,
          checkHealthRisks: false,
          checkState: false,
          checkFlow: true,
          requirePreviousMedicationsAnswer: true,
          requireHighestBMIAnswer: true,
          disabledNamedChecks: [
            "isQualifiedForPD",
            "isNotEligibleForCompoundedSemaglutide",
          ],
        },
        MED_FLOW.CLINICAL
      );

      if (eligibleProducts.length === 0) {
        trackEvent("BmiReasonPlanRevealNavigationFailed", {
          bmi: getBMI(),
        });
      }

      return goto.bail(
        "mainSurvey",
        [],
        "No entry point found for med tier payment results"
      );
    }

    const entryPointLocation = findEntryPointLocation(pageSet, entryPoint);
    return gotoPage(pageSet, { store, history }, false, entryPointLocation);
  },

  async navigateToHealthPlanRevealPage() {
    const store = getStore();
    const history = getHistory();
    const pageSet = await getPageSetFromPath(
      window.location.pathname,
      getStore().getState()
    );

    const { recommendedHealthPlan } = store.getState().recommendationContext;

    if (!recommendedHealthPlan) {
      return goto.bail(
        "mainSurvey",
        [],
        "No plan recommended for health route"
      );
    }

    const entryPoint = "healthCheckResults";
    const entryPointLocation = findEntryPointLocation(pageSet, entryPoint);
    return gotoPage(pageSet, { store, history }, false, entryPointLocation);
  },
};
